module.exports = __webpack_public_path__ + "img/hr-green-small-grass-02.1c7bebe8.png";